export default {
  name: 'errorwrap',
  props: {
    txt: {
      type: String,
      default: ''
    },
    mb: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      state: true
    };
  },
  components: {},
  methods: {
    changeState: function changeState(state) {
      this.state = state;
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};